import React, { useRef, useEffect, useState } from "react";
import I18n from "i18n";
import usersInstance from "collections/usersInstance";
import vent from "libraries/vent";
import DetailViewCommentItem from "./DetailViewCommentItem";

export function DetailViewComment({ agentResult }: { agentResult: any }) {
  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  const [comments, setComments] = useState(agentResult.comments.models);
  const commentsCollection = agentResult.comments;

  useEffect(() => {
    function update() {
      setComments([...commentsCollection.models]);
    }
    commentsCollection.on("add remove change reset", update);
    return () => {
      commentsCollection.off("add remove change reset", update);
    };
  }, [commentsCollection]);

  function handleCreateComment() {
    const text = inputRef.current?.value?.trim();
    if (!text) return;
    const comment = commentsCollection.create(
      {
        creator_id: usersInstance.currentUser.id,
        author: usersInstance.currentUser.get("full_name"),
        text,
      },
      {
        success: () => triggerCommentChange(),
        error: () => {
          commentsCollection.remove(comment);
          triggerCommentChange();
        },
      }
    );
    if (inputRef.current) inputRef.current.value = "";
  }

  function handleUpdateComment(comment: Backbone.Model, newText: string) {
    const previousText = comment.get("text");
    comment.save(
      { text: newText },
      {
        error: () => {
          comment.set("text", previousText);
        },
        success: () => triggerCommentChange(),
      }
    );
  }

  function handleDeleteComment(comment: Backbone.Model) {
    comment.destroy({
      success: () => triggerCommentChange(),
      error: () => {
        commentsCollection.add(comment);
        triggerCommentChange();
      },
    });
  }

  function triggerCommentChange() {
    vent.trigger(
      "changed:resultCommented",
      [agentResult.get("id")],
      commentsCollection.toJSON({ uneditedJSON: true })
    );
  }

  function handleKeyPress(event: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleCreateComment();
    }
  }

  return (
    <div>
      <label htmlFor="commentinput1" className="form-item__label">
        {I18n.t("webapp.agents.results.result_details.comment_headline")}
      </label>
      <div className="form-item__input">
        <textarea
          data-comment-input
          placeholder={I18n.t(
            "webapp.agents.results.result_details.comment_prompt"
          )}
          id="commentinput1"
          className="text-input textarea textarea--expanding textarea--large"
          ref={inputRef}
          onKeyPress={handleKeyPress}
          onBlur={handleCreateComment}
        ></textarea>
      </div>
      <div className="form-item__feedback">
        <i className="icon-spam"></i> Alert if necessary
      </div>
      <ul>
        {comments.map((comment: any) => (
          <li key={comment.cid}>
            <DetailViewCommentItem
              comment={comment}
              currentUserId={usersInstance.currentUser.id}
              onUpdate={handleUpdateComment}
              onDelete={handleDeleteComment}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
